import { jsx as _jsx } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { useAttributeNumberFormatOptions, useConfigurationAttributeEditableUnit, useControlledNumericEdit, useCsAttribute, useNumberFormat, } from "@plansoft-configuration-renderer/framework";
import { useAttributeInlineLabel } from "../../Attributes/useAttributeInlineLabel";
import { useAttributeLayout } from "../../layouts/AttributeLayoutContext";
import { NumericRange } from "./NumericRange/NumericRange";
import { useEditControlLayoutProps } from "./useEditControlLayoutProps";
import { useEditInputProps } from "./useEditInputProps";
/**
 * Numeric editable control
 * @returns
 */
export function NumericEdit() {
    var _a;
    const attribute = useCsAttribute();
    const { fullWidth = false, variant, size, margin } = useAttributeLayout();
    const { labelText } = useAttributeInlineLabel();
    const unitSymbol = useConfigurationAttributeEditableUnit({ mode: "symbol" });
    const { debounceDelay, updateBehavior, showReset, showValueRange } = useEditControlLayoutProps();
    // must be memoized or take from layout
    const numberFormatOptions = useAttributeNumberFormatOptions();
    const numberFormat = useNumberFormat(numberFormatOptions);
    const { isValid, inputValue, handleBlur, handleFocus, handleChange, handleReset, } = useControlledNumericEdit({
        debounceDelay,
        updateBehavior,
        numberFormatOptions,
    });
    const inputProps = useEditInputProps({ handleReset, showReset });
    const helperText = showValueRange && (_jsx(NumericRange, { unitSymbol: unitSymbol, numberFormat: numberFormat, valueMin: attribute.valueMin, valueMax: attribute.valueMax, valueMinExclusive: attribute.valueMinExclusive, valueMaxExclusive: attribute.valueMaxExclusive, valueStepWidth: attribute.valueStepWidth }));
    const isDisabled = !attribute.isAllowed;
    const isReadOnly = (_a = attribute.isReadOnly) !== null && _a !== void 0 ? _a : false;
    return (_jsx(TextField, { fullWidth: fullWidth, variant: variant, size: size, margin: margin, label: labelText, helperText: helperText, required: attribute.isRequired, disabled: isDisabled || isReadOnly, type: "text", color: isValid ? undefined : "error", value: inputValue, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, slotProps: {
            input: inputProps,
        } }));
}
//# sourceMappingURL=Edit.NumericEdit.js.map